<template>
    <div>
        <h6 v-if="(profileId != 0)" class="heading-small text-muted mb-4">{{ (siteName) ? (this.siteName) : "" }}</h6>
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
        <form id="form-proper">
            <div>
                 <div class="row">
                    <div class="col">
                        <br>
                        <p class="h4">Set Terminal Access</p>
                        <p style="line-height: 90%;"><small>Select terminals that can access this pos wavelet.</small></p>
                        <base-input alternative="" label="">
                            <a-select v-model="selectedTerminals" mode="multiple" placeholder="Select Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"  :disabled="viewMode">
                                <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>
                    </div>
                </div>
            </div>
            <div>
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button  type="button" class="btn btn-primary float-right" @click.prevent="updatePurchase">Update</button> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        props: {
            type: {
            type: String
            },
            title: String,
            accountPosWaveletId: {  
            type: Number, 
            required: true 
            },
            waveletId: {  
            type: Number, 
            required: true 
            }
        },
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            component_x = this
            component_x.site_id = component_x.profileId
            
            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.site_id, null);
            component_x.terminalOptions = terminals;

            if (component_x.profileId > 0){
                let wavelet_site_terminals = await HTTPRequest.getRequest(component_x.endPoint + 'pos_wavelet_terminals/get_terminals_by_site_id?site_id=' + component_x.site_id+'&account_pos_wavelet_id='+component_x.accountPosWaveletId, null)
                if(wavelet_site_terminals == undefined){
                    component_x.$router.go()
                } else {
                    if(wavelet_site_terminals["error"] == undefined){
                        component_x.selectedTerminals = wavelet_site_terminals.terminal_ids
                        component_x.siteName = wavelet_site_terminals.site_name
                    } else {
                        this.errors = wavelet_site_terminals["error"].split(",");
                    } 
                }
            }
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                errors: [],
                profileData: {},
                formErrors: [],
                terminalOptions: [],
                selectedTerminals: [],
                siteName: '',
                site_id: null,
                mode: 2,
                viewMode: this.$attrs.viewMode

            }
        },
        methods: {
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            async updatePurchase(){
                var wavelet_payload = {"wavelet_id": this.waveletId, "terminal_site_id": this.site_id, "selected_terminal_ids": this.selectedTerminals, "mode": this.mode}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/update_purchase_settings', null, wavelet_payload)
                if (post_request.status == 'success') {
                    this.$notification['success']({
                        message: 'Wavelet Markeplace',
                        description: "Purchase update success"
                    });
                    this.$emit('refreshPage', event)
                } else {
                    this.$notification['error']({
                        message: 'Wavelet Marketplace',
                        description: "Purchase update error: " + post_request.error
                    }); 
                }
            },
        }
    }
</script>

<style>
</style>